import { unitTypes } from '@generators/tresholdConstants'
// 000.000.000-00

export const cpfMask = (value) => {
  return value
    ?.replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}
// 0000.0000.000000.00
export const insuranceMask = (value) => {
  return value
    ?.replace(/[^\d*]/g, '')
    .replace(/([\d*]{4})([\d*])/, '$1.$2') // captura 2 grupos de numero o primeiro de 4 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/([\d*]{4})([\d*])/, '$1.$2')
    .replace(/([\d*]{6})([\d*]{1,2})/, '$1.$2')
}
export const cpfShowMask = (value) => {
  return value
    ?.replace(/[^\d*]/g, '')
    .replace(/([\d*]{3})([\d*])/, '$1.$2')
    .replace(/([\d*]{3})([\d*])/, '$1.$2')
    .replace(/([\d*]{3})([\d*]{1,2})/, '$1-$2')
    .replace(/(-[\d*]{2})[\d*]+?$/, '$1')
}
// 00/00/0000
export const dateMask = (value) => {
  return value
    ?.replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

// (00) 00000-0000

export const phoneMask = (value) => {
  return value
    ?.replace(/\D/g, '')
    .substring(0, 11)
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})$/, '$1-$2')
}

// only numbers
export const onlyNumbersMask = (value, sizeLimit) => {
  if (sizeLimit && value.length > sizeLimit) {
    return value?.substring(0, sizeLimit)
  }
  return value?.replace(/\D/g, '')
}

// only not numbers
export const onlyNotNumbersMask = (value) => {
  return value?.replace(/[^a-zA-ZÀ-ÿ\s]/g, '')
}

export function hexToRgbA(hex, opc) {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = `0x${c.join('')}`
    return `rgba(${
      // eslint-disable-next-line no-bitwise
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')
    },${opc || '1'})`
  }
  return '#FFFFFF'
}

export const getInitials = (nameString) => {
  return nameString
    ? nameString
      .match(/(\b\S)?/g)
      .join('')
      .match(/(^\S|\S$)?/g)
      .join('')
      .toUpperCase()
    : '..'
}

export const isValidCPF = (cpf) => {
  // Validar se é String
  if (typeof cpf !== 'string') return false

  // Tirar formatação
  // eslint-disable-next-line no-param-reassign
  cpf = cpf.replace(/[^\d]+/g, '')

  // Validar se tem tamanho 11 ou se é uma sequência de digitos repetidos
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false

  // String para Array
  // eslint-disable-next-line no-param-reassign
  cpf = cpf.split('')

  const validator = cpf
    // Pegar os últimos 2 digitos de validação
    .filter((digit, index, array) => index >= array.length - 2 && digit)
    // Transformar digitos em números
    .map((el) => +el)

  const toValidate = (pop) => cpf
    // Pegar Array de items para validar
    .filter((digit, index, array) => index < array.length - pop && digit)
    // Transformar digitos em números
    .map((el) => +el)

  const rest = (count, pop) => (toValidate(pop)
    // Calcular Soma dos digitos e multiplicar por 10
    .reduce((soma, el, i) => soma + el * (count - i), 0) * 10)
        // Pegar o resto por 11
        % 11
        // transformar de 10 para 0
        % 10

  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])

}

export const oneDecimalMask = (value) => {
  return value?.toFixed(1).toString().replace('.', ',')
}

export const characteristicMask = (type, value) => {
  return type === 'calories' || type === 'visceralFat'
    ? `${value}${unitTypes[type]}`
    : `${oneDecimalMask(value)}${unitTypes[type]}`
}
export const onlyLettersMask = (value) => {
  return value?.replace(/[^a-zA-Z ]/g, '')
}
